import {Suspense, lazy} from 'react';
import {ROUTE_ADD_SURVEY, ROUTE_EDIT_SURVEY, ROUTE_SURVEY} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';

const Survey = lazy(() =>
  import('../../../screens/Survey')
    .then(module => ({default:module.Survey})));

const CreateSurvey = lazy(() => 
  import('../../../screens/Survey')
    .then(module => ({default:module.CreateSurvey})));

const UpdateSurvey = lazy(() => 
  import('../../../screens/Survey')
    .then(module => ({default:module.UpdateSurvey})));

const SurveyNavigation = [
  {
    path: ROUTE_SURVEY,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Survey />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_SURVEY,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <CreateSurvey />
      </Suspense>
    ),
  },
  {
    path: ROUTE_EDIT_SURVEY,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <UpdateSurvey />
      </Suspense>
    ),
  },
];

export default SurveyNavigation;
